import MediaQueries, {breakpoint} from '~/constants/MediaQueries';

export function isDesktop() {
  return breakpoint(MediaQueries.mediumAndAbove);
}

export function isMobile() {
  return !breakpoint(MediaQueries.mediumAndAbove);
}
